// Englische Fassung von ../de/settings.ts.
import type { SettingsKatalog } from "../de/settings";

export const settings: SettingsKatalog = {
  kopfTitel: "Settings",
  kopfUntertitel: (istAdmin) =>
    "Profile, appearance, mail, calendar, AI models and external integrations" +
    (istAdmin ? " — and, as an Atlas admin, org-wide settings." : "."),

  // Zweisprachig in BEIDEN Katalogen — wer die Oberfläche gerade nicht lesen
  // kann, sucht genau nach diesem Wort.
  spracheTitel: "Sprache / Language",
  spracheHinweis:
    "Interface language. Takes effect immediately and applies to all your devices. " +
    "The switch lands step by step: the standard areas first, " +
    "the studio areas stay German for now.",
  spracheHinweisMail:
    "Generated mail replies and follow-up messages still follow the language of " +
    "the incoming message — not this setting.",
  // „TT.MM.JJJJ" und nicht „DD.MM.YYYY": der Hinweis muss die Maske nennen, die
  // WIRKLICH dasteht — die Datumsfelder zeigen auch in der englischen Oberfläche
  // den deutschen Platzhalter (en/calendar.ts::platzhalterDatum). Eine
  // übersetzte Notation hier wäre eine Zusage, die das Feld nicht einhält.
  spracheHinweisDatum: "Date and number formats stay German (TT.MM.JJJJ).",
  spracheDeutsch: "Deutsch",
  spracheEnglisch: "English",
  spracheSpeichert: " · saving …",
  spracheFehler: "Language could not be saved",

  erscheinungsbildTitel: "Appearance",
  erscheinungsbildHinweis: "Colour world and light/dark mode. Applies per browser.",
  presetName: {
    lab: "Lab",
    warm: "Warm",
    weiss: "White",
  },
  presetHinweis: {
    lab: "Clear & scientific",
    warm: "The familiar Atlas look",
    weiss: "Pure white, separated by lines",
  },
  presetEigenes: "Custom",
  presetEigenesHinweis: "Pick your own accent",
  akzentfarbe: "Accent colour",
  akzentfarbeHinweis: "The ramp is calculated automatically.",
  canvasTon: "Canvas tone",
  canvasReinweiss: "Pure white",
  canvasGetoent: "Slightly tinted",
  linien: "Lines",
  linienDezent: "Subtle",
  linienKraeftig: "Strong",
  modus: {
    light: "Light",
    dark: "Dark",
    system: "System",
  },

  schriftgroesseTitel: "Font size",
  schriftgroesseHinweis:
    "Scales the entire interface. Takes effect immediately and is stored per browser.",
  schriftgroesse: {
    s: "Small",
    m: "Medium",
    l: "Large",
    xl: "Very large",
  },
  schriftgroesseFehler: "Font size could not be stored",
  speichert: " · saving …",

  schriftartTitel: "Font",
  schriftartHinweis:
    "Applies to the entire interface. Takes effect immediately and applies to all your devices.",
  schriftartFehler: "Font could not be saved",
  schriftartNichtInstalliert:
    "Not installed on this device — it renders Segoe UI. (Your IT can roll out Aptos.)",
  schriftart: {
    inter: { label: "Inter", hinweis: "The Atlas default typeface." },
    system: {
      label: "System (Segoe UI)",
      hinweis: "The Windows system font — nothing is downloaded.",
    },
    "open-sans": { label: "Open Sans", hinweis: "Open and calm, very familiar." },
    aptos: { label: "Aptos", hinweis: "The Office default typeface since 2024." },
    "ibm-plex": { label: "IBM Plex Sans", hinweis: "Technical, with clear figures." },
    "source-sans": { label: "Source Sans 3", hinweis: "More compact — more text per line." },
    atkinson: {
      label: "Atkinson Hyperlegible",
      hinweis: "Accessible: slashed zero, clearly separated shapes.",
    },
  },

  quellenTitel: "Sources in the chat",
  quellenHinweis: "How the sources under an answer are shown by default.",
  quellenFehler: "Source default could not be stored",
  quellen: {
    collapsed: {
      label: "Collapsed",
      hinweis: "Only the 'N sources' hint, everything else on click.",
    },
    titles: {
      label: "Titles",
      hinweis: "Source list open, cards as a title row.",
    },
    expanded: {
      label: "With content",
      hinweis: "Source list open, every card expanded with its chunk.",
    },
  },

  aufgabenAnsichtTitel: "Task view",
  aufgabenAnsichtHinweis:
    "How a task opens first when you click a kanban card. " +
    "Switchable at any time via the header toggle in the task window. Applies per browser.",
  aufgabenAnsicht: {
    compact: {
      label: "Compact",
      hinweis: "Only the core fields: title, status, due date, workstream, notes.",
    },
    detailed: {
      label: "Detailed",
      hinweis: "Everything: goal, acceptance, subtasks, assignment, activity.",
    },
  },

  seitenleisteTitel: "Sidebar",
  seitenleisteAusgeklappt: "Start with projects expanded in the sidebar",
};
